import client from '../client';
import {
  CreateAccountMutationVariables,
  CreateAccountMutation
} from '../../queries/__generated__/CreateAccountMutation';
import { createAccountMutation, accountsQuery } from '../../queries/account';

interface User {
  id: string;
  email: string;
}

export async function createAccount(name: string, user: User) {
  const res = await client.mutate<CreateAccountMutation, CreateAccountMutationVariables>({
    mutation: createAccountMutation,
    variables: {
      input: {
        name,
        displayName: user.email,
        ownerId: user.id
      }
    },
    refetchQueries: [{ query: accountsQuery }]
  });

  return res.data!.createAccount;
}
